/**
 * PlanetChip — small chip with planet glyph + name + ecliptic degree.
 * Verbatim port of mobile.html `.planet-chip`.
 *
 * When `onSelect` is supplied the chip becomes a tappable button (tap → open
 * the explanation sheet on the natal chart); otherwise it stays a static `div`.
 */
import type { ReactElement } from "react";

export interface PlanetChipProps {
  readonly glyph: string;
  readonly name: string;
  readonly degree: string;
  /** When provided, the chip renders as a button and calls this on tap. */
  readonly onSelect?: () => void;
}

export function PlanetChip({ glyph, name, degree, onSelect }: PlanetChipProps): ReactElement {
  const inner = (
    <>
      <span className="gly" aria-hidden="true">
        {glyph}
      </span>
      <span>{name}</span>
      <span className="deg">{degree}</span>
    </>
  );

  if (onSelect) {
    return (
      <button
        type="button"
        className="planet-chip"
        style={{ textAlign: "left", width: "100%" }}
        onClick={onSelect}
      >
        {inner}
      </button>
    );
  }

  return <div className="planet-chip">{inner}</div>;
}
